export const AppointmentType = {
  GET_APPOINTMENT_DATA: "GET_APPOINTMENT_DATA",
  EDIT_APPOINTMENT_DATA: "EDIT_APPOINTMENT_DATA",
};
